require('./bootstrap_8');

require('alpinejs');
